export default __webpack_public_path__ + "static/media/archive-old.90e08221.svg";